function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTobacoNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.79,
    y: 159.57,
    width: 58.67,
    height: 7.33,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.79,
    y: 159.57,
    width: 17,
    height: 7.33,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,159.57h-5.77c-.89.85.33.39.44,2.16.06,1-4,1.17-.83,1.84a2.16,2.16,0,0,1,1.33,1c.25.53-1,1.26-.37,2.33h5.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.45,159.57H152.3a2.15,2.15,0,0,0,.9,2.41c1.59.94-1.42,3.07-1,4.92h3.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.23,117.26a43.66,43.66,0,1,0,43.65,43.66A43.66,43.66,0,0,0,127.23,117.26Zm-34,43.66a34,34,0,0,1,54.29-27.2L100,181.25A33.84,33.84,0,0,1,93.27,160.92Zm34,34a33.85,33.85,0,0,1-20.34-6.76l47.53-47.53a34,34,0,0,1-27.19,54.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.28,
    y: 198.5,
    width: 37.05,
    height: 4.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.28,
    y: 198.5,
    width: 10.73,
    height: 4.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.33,198.5h-3.65c-.57.54.21.25.28,1.37,0,.63-2.53.73-.53,1.15a1.39,1.39,0,0,1,.84.64c.16.33-.66.79-.23,1.47h3.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.33,198.5h-2a1.38,1.38,0,0,0,.57,1.53c1,.59-.89,1.93-.61,3.1h2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5,171.79a27.57,27.57,0,1,0,27.57,27.56A27.56,27.56,0,0,0,411.5,171.79Zm-21.44,27.56a21.44,21.44,0,0,1,34.28-17.17l-30,30A21.34,21.34,0,0,1,390.06,199.35Zm21.44,21.44a21.37,21.37,0,0,1-12.84-4.27l30-30a21.44,21.44,0,0,1-17.17,34.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.64,
    y: 95.61,
    width: 27.15,
    height: 3.39,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.64,
    y: 95.61,
    width: 7.87,
    height: 3.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,95.61h-2.67c-.42.4.15.19.2,1,0,.46-1.85.54-.38.85a1,1,0,0,1,.61.46c.12.25-.48.58-.17,1.08h2.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,95.61h-1.46a1,1,0,0,0,.42,1.12c.73.44-.66,1.42-.45,2.28h1.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73,76a20.2,20.2,0,1,0,20.2,20.2A20.2,20.2,0,0,0,272.73,76ZM257,96.24a15.73,15.73,0,0,1,25.13-12.59l-22,22A15.67,15.67,0,0,1,257,96.24ZM272.73,112a15.6,15.6,0,0,1-9.41-3.13l22-22A15.71,15.71,0,0,1,272.73,112Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-254"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-254",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-254"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "137.95 272.38 137.95 270.8 134.54 269.67 129.71 269.67 126.29 270.8 126.29 272.38 126.29 408.83 126.29 410.41 129.71 411.54 134.54 411.54 137.95 410.41 137.95 408.83 137.95 272.38",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.87 326.5 129.34 326.5 129.34 269.8 126.29 270.8 126.29 272.38 126.29 408.83 126.29 410.41 129.34 411.42 129.34 338.99 135.87 338.5 135.87 326.5",
    style: {
      fill: "#263238",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.54 269.67 129.71 269.67 126.29 270.8 126.29 272.38 129.71 273.5 134.54 273.5 137.95 272.38 137.95 270.8 134.54 269.67",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.54 269.67 129.71 269.67 126.29 270.8 126.29 272.38 129.71 273.5 134.54 273.5 137.95 272.38 137.95 270.8 134.54 269.67",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.24 290.14 180.25 276.67 84.71 276.67 67.72 290.14 65.81 292.04 65.81 318.97 82.81 332.44 178.35 332.44 195.34 318.97 197.24 317.07 197.24 290.14",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.25 330.54 197.24 317.07 197.24 290.14 180.25 276.67 84.71 276.67 67.72 290.14 67.72 317.07 84.71 330.54 180.25 330.54",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.93,320.79H92.66a1.07,1.07,0,0,1-1.07-1.07h0a1.07,1.07,0,0,1,1.07-1.08h12.27a1.07,1.07,0,0,1,1.07,1.08h0A1.07,1.07,0,0,1,104.93,320.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93,316.1H85.06A1.07,1.07,0,0,1,84,315h0A1.07,1.07,0,0,1,85.06,314h19.87A1.07,1.07,0,0,1,106,315h0A1.07,1.07,0,0,1,104.93,316.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.93,311.4H92.66a1.07,1.07,0,0,1-1.07-1.07h0a1.07,1.07,0,0,1,1.07-1.07h12.27a1.07,1.07,0,0,1,1.07,1.07h0A1.07,1.07,0,0,1,104.93,311.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.94,320.79h12.27a1.07,1.07,0,0,0,1.07-1.07h0a1.07,1.07,0,0,0-1.07-1.08H156.94a1.07,1.07,0,0,0-1.07,1.08h0A1.07,1.07,0,0,0,156.94,320.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94,316.1h19.87a1.07,1.07,0,0,0,1.07-1.08h0a1.07,1.07,0,0,0-1.07-1.07H156.94a1.07,1.07,0,0,0-1.07,1.07h0A1.07,1.07,0,0,0,156.94,316.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94,311.4h12.27a1.07,1.07,0,0,0,1.07-1.07h0a1.07,1.07,0,0,0-1.07-1.07H156.94a1.07,1.07,0,0,0-1.07,1.07h0A1.07,1.07,0,0,0,156.94,311.4Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-254"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.91,292.39v10.2H87l-5.08-6.19v6.19H79.56v-10.2h2l5.07,6.19v-6.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4,302.08a5.27,5.27,0,0,1-2-7.29,5.1,5.1,0,0,1,2-1.89,6.35,6.35,0,0,1,5.72,0,5.17,5.17,0,0,1,2,1.89,5.21,5.21,0,0,1-2,7.29,6.35,6.35,0,0,1-5.72,0Zm4.49-1.74A3,3,0,0,0,99,299.18a3.69,3.69,0,0,0,0-3.38,3.05,3.05,0,0,0-1.15-1.16,3.26,3.26,0,0,0-1.63-.41,3.32,3.32,0,0,0-1.63.41,3.1,3.1,0,0,0-1.14,1.16,3.61,3.61,0,0,0,0,3.38,3,3,0,0,0,1.14,1.16,3.21,3.21,0,0,0,1.63.41A3.16,3.16,0,0,0,97.89,300.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,297.58h4.13v1.82h-4.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89,294.32h-3.27v-1.93h8.89v1.93h-3.26v8.27h-2.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.71,302.08a5.06,5.06,0,0,1-2-1.89,5.2,5.2,0,0,1,2-7.29,6,6,0,0,1,2.86-.68,5.94,5.94,0,0,1,2.85.68,5.27,5.27,0,0,1,2,7.29,5.13,5.13,0,0,1-2,1.89,5.83,5.83,0,0,1-2.85.68A5.9,5.9,0,0,1,119.71,302.08Zm4.49-1.74a3,3,0,0,0,1.14-1.16,3.61,3.61,0,0,0,0-3.38,3,3,0,0,0-1.14-1.16,3.45,3.45,0,0,0-3.26,0,3.05,3.05,0,0,0-1.15,1.16,3.69,3.69,0,0,0,0,3.38,3,3,0,0,0,1.15,1.16,3.45,3.45,0,0,0,3.26,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,298.21a2.58,2.58,0,0,1,.49,1.6,2.34,2.34,0,0,1-1,2.06,5.3,5.3,0,0,1-3,.72h-5.28v-10.2h5a4.87,4.87,0,0,1,2.87.72,2.26,2.26,0,0,1,1,1.94,2.43,2.43,0,0,1-1.35,2.24A2.68,2.68,0,0,1,138.78,298.21Zm-6.51-4v2.4h2.34a2.4,2.4,0,0,0,1.33-.3,1,1,0,0,0,.45-.9,1,1,0,0,0-.45-.9,2.4,2.4,0,0,0-1.33-.3Zm4.16,6.34a1.07,1.07,0,0,0,.47-.95c0-.84-.63-1.27-1.88-1.27h-2.75v2.52H135A2.69,2.69,0,0,0,136.43,300.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,300.41h-4.73l-.91,2.18h-2.41l4.54-10.2h2.33l4.56,10.2h-2.48Zm-.74-1.8-1.62-3.9-1.62,3.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,302.09a5,5,0,0,1-2-1.88,5.48,5.48,0,0,1,0-5.43,5,5,0,0,1,2-1.88,5.89,5.89,0,0,1,2.83-.68,6,6,0,0,1,2.4.47,4.78,4.78,0,0,1,1.8,1.34l-1.52,1.39a3.27,3.27,0,0,0-2.56-1.19,3.46,3.46,0,0,0-1.69.41,3,3,0,0,0-1.16,1.16,3.61,3.61,0,0,0,0,3.38,2.94,2.94,0,0,0,1.16,1.16,3.36,3.36,0,0,0,1.69.41,3.24,3.24,0,0,0,2.56-1.2l1.52,1.39a4.69,4.69,0,0,1-1.81,1.36,6,6,0,0,1-2.4.46A5.87,5.87,0,0,1,154.14,302.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.6,302.09a5.32,5.32,0,0,1-2-7.31,5.07,5.07,0,0,1,2-1.88,6.27,6.27,0,0,1,5.22-.21,4.63,4.63,0,0,1,1.8,1.34l-1.51,1.39a3.29,3.29,0,0,0-2.57-1.19,3.43,3.43,0,0,0-1.68.41,2.94,2.94,0,0,0-1.16,1.16,3.61,3.61,0,0,0,0,3.38,2.88,2.88,0,0,0,1.16,1.16,3.32,3.32,0,0,0,1.68.41,3.26,3.26,0,0,0,2.57-1.2l1.51,1.39a4.58,4.58,0,0,1-1.8,1.36,6,6,0,0,1-2.41.46A5.83,5.83,0,0,1,164.6,302.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07,302.08a5.06,5.06,0,0,1-2-1.89,5.2,5.2,0,0,1,2-7.29,6,6,0,0,1,2.86-.68,5.94,5.94,0,0,1,2.85.68,5.2,5.2,0,0,1,2,1.89,5.36,5.36,0,0,1,0,5.4,5.13,5.13,0,0,1-2,1.89,5.83,5.83,0,0,1-2.85.68A5.9,5.9,0,0,1,175.07,302.08Zm4.49-1.74a2.89,2.89,0,0,0,1.14-1.16,3.61,3.61,0,0,0,0-3.38,3,3,0,0,0-1.14-1.16,3.45,3.45,0,0,0-3.26,0,3,3,0,0,0-1.14,1.16,3.61,3.61,0,0,0,0,3.38,2.89,2.89,0,0,0,1.14,1.16,3.45,3.45,0,0,0,3.26,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34,309.26h5.24a7.34,7.34,0,0,1,3.32.72,5.42,5.42,0,0,1,2.24,2,6.19,6.19,0,0,1,0,6.05,5.42,5.42,0,0,1-2.24,2,7.34,7.34,0,0,1-3.32.72h-5.24Zm5.11,9.34a3.86,3.86,0,0,0,2.76-1,3.85,3.85,0,0,0,0-5.22,3.9,3.9,0,0,0-2.76-1H117v7.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.37,318.32H130l-1,2.47h-2.74l5.14-11.53H134l5.15,11.53h-2.8Zm-.84-2-1.83-4.41-1.83,4.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.21,316.7v4.09h-2.66v-4.12l-4.46-7.41h2.83l3.08,5.12,3.08-5.12h2.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.17,291.13v10.19H88.24l-5.09-6.19v6.19H80.82V291.13h2l5.06,6.19v-6.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.67,300.81a5,5,0,0,1-2-1.88,5.15,5.15,0,0,1-.72-2.7,5.21,5.21,0,0,1,.72-2.71,5,5,0,0,1,2-1.88,5.9,5.9,0,0,1,2.86-.69,5.84,5.84,0,0,1,2.85.69,5.1,5.1,0,0,1,2,1.88,5.21,5.21,0,0,1,.73,2.71,5.15,5.15,0,0,1-.73,2.7,5.1,5.1,0,0,1-2,1.88,5.84,5.84,0,0,1-2.85.69A5.9,5.9,0,0,1,94.67,300.81Zm4.49-1.74a2.87,2.87,0,0,0,1.14-1.15,3.39,3.39,0,0,0,.42-1.69,3.34,3.34,0,0,0-.42-1.69,2.89,2.89,0,0,0-1.14-1.16,3.37,3.37,0,0,0-3.26,0,2.89,2.89,0,0,0-1.14,1.16,3.34,3.34,0,0,0-.42,1.69,3.39,3.39,0,0,0,.42,1.69,2.87,2.87,0,0,0,1.14,1.15,3.37,3.37,0,0,0,3.26,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,296.31h4.12v1.82h-4.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,293.05h-3.26v-1.92h8.89v1.92h-3.27v8.27h-2.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,300.81a5,5,0,0,1-2-1.88,5.15,5.15,0,0,1-.72-2.7,5.21,5.21,0,0,1,.72-2.71,5,5,0,0,1,2-1.88,6.27,6.27,0,0,1,5.72,0,5.2,5.2,0,0,1,0,9.17,6.27,6.27,0,0,1-5.72,0Zm4.5-1.74a3,3,0,0,0,1.14-1.15,3.38,3.38,0,0,0,.41-1.69,3.33,3.33,0,0,0-.41-1.69,3,3,0,0,0-1.14-1.16,3.39,3.39,0,0,0-3.27,0,3,3,0,0,0-1.14,1.16,3.34,3.34,0,0,0-.42,1.69,3.39,3.39,0,0,0,.42,1.69,3,3,0,0,0,1.14,1.15,3.39,3.39,0,0,0,3.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.05,297a2.53,2.53,0,0,1,.49,1.59,2.35,2.35,0,0,1-1,2.06,5.35,5.35,0,0,1-3,.72h-5.27V291.13h5a4.91,4.91,0,0,1,2.86.71,2.25,2.25,0,0,1,1,1.94,2.48,2.48,0,0,1-1.35,2.24A2.69,2.69,0,0,1,140.05,297Zm-6.52-4.05v2.41h2.35a2.36,2.36,0,0,0,1.33-.31,1.12,1.12,0,0,0,0-1.8,2.45,2.45,0,0,0-1.33-.3Zm4.16,6.34a1,1,0,0,0,.48-.95c0-.84-.63-1.26-1.88-1.26h-2.76v2.52h2.76A2.62,2.62,0,0,0,137.69,299.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,299.14h-4.74l-.9,2.18H141l4.55-10.19h2.33l4.56,10.19H150Zm-.75-1.79-1.61-3.91-1.62,3.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,300.82a5,5,0,0,1-2-1.88,5.48,5.48,0,0,1,0-5.43,5,5,0,0,1,2-1.88,6.29,6.29,0,0,1,5.23-.21,4.73,4.73,0,0,1,1.8,1.34l-1.51,1.4a3.26,3.26,0,0,0-2.57-1.2,3.39,3.39,0,0,0-1.69.42,2.92,2.92,0,0,0-1.15,1.16,3.34,3.34,0,0,0-.42,1.69,3.39,3.39,0,0,0,.42,1.69,2.89,2.89,0,0,0,1.15,1.15,3.39,3.39,0,0,0,1.69.42,3.24,3.24,0,0,0,2.57-1.21l1.51,1.4a4.73,4.73,0,0,1-1.8,1.35,6,6,0,0,1-2.41.47A5.88,5.88,0,0,1,155.4,300.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.86,300.82a5,5,0,0,1-2-1.88,5.48,5.48,0,0,1,0-5.43,5,5,0,0,1,2-1.88,6.29,6.29,0,0,1,5.23-.21,4.89,4.89,0,0,1,1.8,1.34l-1.51,1.4a3.26,3.26,0,0,0-2.57-1.2,3.39,3.39,0,0,0-1.69.42,3,3,0,0,0-1.16,1.16,3.44,3.44,0,0,0-.41,1.69,3.49,3.49,0,0,0,.41,1.69,3,3,0,0,0,1.16,1.15,3.39,3.39,0,0,0,1.69.42,3.24,3.24,0,0,0,2.57-1.21l1.51,1.4a4.76,4.76,0,0,1-1.81,1.35,6,6,0,0,1-2.4.47A5.88,5.88,0,0,1,165.86,300.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.33,300.81a5,5,0,0,1-2-1.88,5.15,5.15,0,0,1-.72-2.7,5.21,5.21,0,0,1,.72-2.71,5,5,0,0,1,2-1.88,5.94,5.94,0,0,1,2.87-.69,5.86,5.86,0,0,1,2.85.69,5.1,5.1,0,0,1,2,1.88,5.21,5.21,0,0,1,.72,2.71,5,5,0,0,1-2.72,4.58,5.86,5.86,0,0,1-2.85.69A5.94,5.94,0,0,1,176.33,300.81Zm4.5-1.74a3,3,0,0,0,1.14-1.15,3.39,3.39,0,0,0,.42-1.69,3.34,3.34,0,0,0-.42-1.69,3,3,0,0,0-1.14-1.16,3.39,3.39,0,0,0-3.27,0,3,3,0,0,0-1.14,1.16,3.33,3.33,0,0,0-.41,1.69,3.38,3.38,0,0,0,.41,1.69,3,3,0,0,0,1.14,1.15,3.39,3.39,0,0,0,3.27,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.61,308h5.24a7.29,7.29,0,0,1,3.31.71,5.36,5.36,0,0,1,2.24,2,6.14,6.14,0,0,1,0,6.06,5.34,5.34,0,0,1-2.24,2,7.3,7.3,0,0,1-3.31.72h-5.24Zm5.1,9.33a3.86,3.86,0,0,0,2.76-1,3.82,3.82,0,0,0,0-5.22,3.87,3.87,0,0,0-2.76-1h-2.43v7.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.64,317.05h-5.36l-1,2.47h-2.73L132.67,308h2.63l5.16,11.52h-2.8Zm-.84-2L134,310.61,132.14,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.48,315.44v4.08h-2.67V315.4l-4.46-7.4h2.83l3.08,5.12,3.08-5.12H151Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cigarette--inject-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.06,404.65c0,2.87-15.91,5.2-35.53,5.2S332,407.52,332,404.65V270.06l20.1-6.76L332,243.43V89.11c0-2.86,15.9-5.19,35.53-5.19s35.53,2.33,35.53,5.19Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,404.65c0,2.87-15.91,5.2-35.53,5.2S332,407.52,332,404.65V270.06l20.1-6.76L332,243.43V89.11c0-2.86,15.9-5.19,35.53-5.19s35.53,2.33,35.53,5.19Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "332 243.43 347.18 258.44 347.18 92.23 332 92.23 332 243.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,275.26c2.64,1.21,8.07,2.23,15.18,2.91V265L332,270.06v5.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332,270.06h60.85s-15.54-30.46-45.67-30.46c-6.69,0-11.59,1.5-15.18,3.84l20.1,19.86L332,270.06Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,270.06h60.85s-15.54-30.46-45.67-30.46c-6.69,0-11.59,1.5-15.18,3.84l20.1,19.86L332,270.06Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,279.05c-16.63,0-30.72-1.59-35.53-3.79V404.65c0,2.87,15.9,5.2,35.53,5.2s35.53-2.33,35.53-5.2V275.26C398.24,277.46,384.16,279.05,367.53,279.05Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.53,279.05c-16.63,0-30.72-1.59-35.53-3.79V404.65c0,2.87,15.9,5.2,35.53,5.2s35.53-2.33,35.53-5.2V275.26C398.24,277.46,384.16,279.05,367.53,279.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.43 303.04 356.92 310.16 362.43 310.16 367.53 306.6 362.43 303.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.35 337.55 371.28 342.56 376.35 342.56 376.35 337.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.85 312.35 384.43 315.09 388.64 320.02 392.85 312.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.85 370.97 384.43 375.36 388.64 380.16 392.85 370.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.22 391 367.53 396.59 359.6 398.55 362.22 391",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.18,278.17c-7.11-.68-12.54-1.7-15.18-2.91V404.65c0,1.76,6,3.32,15.18,4.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.85,270.06s-13.53-7-33.25-7c-2.7,0-5.33.13-7.89.35L332,270.06h60.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,83.92c-19.63,0-35.53,2.33-35.53,5.19v42.06c4.23,2,12,3.73,17.37-6.79,7.67-15.1,14.4-11.08,18.16-5.6s9.6,2.55,14-.73,11.76-3.54,15-8.77c1.62-2.64,4.31-2.61,6.57-1.94V89.11C403.06,86.25,387.15,83.92,367.53,83.92Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,83.92c-19.63,0-35.53,2.33-35.53,5.19v33.48c3.87,1.73,10.71,3.58,15.91-1.62,7.67-7.67,10-13.52,19.62-8.77s22.75.37,25.67-5.11c1.72-3.23,6-2.91,9.86-3.3V89.11C403.06,86.25,387.15,83.92,367.53,83.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.53,83.92c-19.63,0-35.53,2.33-35.53,5.19v33.48c3.87,1.73,10.71,3.58,15.91-1.62,7.67-7.67,10-13.52,19.62-8.77s22.75.37,25.67-5.11c1.72-3.23,6-2.91,9.86-3.3V89.11C403.06,86.25,387.15,83.92,367.53,83.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.24 102.33 334.68 106.85 340.43 109.2 343.24 102.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.24 101.33 376.35 103.91 379.63 105.25 381.24 101.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.02 97.59 359.6 100.88 356.31 104.15 353.02 100.88 353.02 97.59",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.06,89.11c0,2.87-15.91,5.2-35.53,5.2S332,92,332,89.11s15.9-5.19,35.53-5.19S403.06,86.25,403.06,89.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,86.05a5,5,0,0,0-10-.84h-.08a7.15,7.15,0,0,0-5.24,2.28A7.18,7.18,0,0,0,372.8,87a8.43,8.43,0,0,0-9.32,3.26A5,5,0,1,0,362,100.1a4.74,4.74,0,0,0,1.51-.26,8.4,8.4,0,0,0,14.68-1.59,4.58,4.58,0,0,0,.53,0A7.15,7.15,0,0,0,383.93,96a7.17,7.17,0,0,0,12.39,0,5,5,0,0,0,3.21-7.43A5.05,5.05,0,0,0,400.23,86.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,86.05a5,5,0,0,0-10-.84h-.08a7.15,7.15,0,0,0-5.24,2.28A7.18,7.18,0,0,0,372.8,87a8.43,8.43,0,0,0-9.32,3.26A5,5,0,1,0,362,100.1a4.74,4.74,0,0,0,1.51-.26,8.4,8.4,0,0,0,14.68-1.59,4.58,4.58,0,0,0,.53,0A7.15,7.15,0,0,0,383.93,96a7.17,7.17,0,0,0,12.39,0,5,5,0,0,0,3.21-7.43A5.05,5.05,0,0,0,400.23,86.05Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.67 114.78 338.97 116.43 337.32 118.06 335.67 116.43 335.67 114.78",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-254"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.6,253.89s14.11,6.37,29.72,6.1c0,0-1.29-2.7,9.18-5.32l-4.45-3-20.14-1.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,253.89s14.11,6.37,29.72,6.1c0,0-1.29-2.7,9.18-5.32l-4.45-3-20.14-1.57Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.27 252.63 346.71 248.01 328.6 253.89 346.27 252.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.27 252.63 346.71 248.01 328.6 253.89 346.27 252.63",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 354.79,
    y: 240.68,
    width: 4.64,
    height: 21.33,
    transform: "translate(72.86 582.85) rotate(-84.53)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.23,258.08l-.82-1.47c-.81-1.48-10.27,2.7-7.85,0s-9.4-.36-7.67-1.94c.7-.64-1.68-1.12-4.77-1.46l-9.52.68s14.11,6.37,29.72,6.1C358.32,260,358,259.21,359.23,258.08Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.45 383.01 185.54 400.74 178.58 397.75 184.8 379.06 193.45 383.01",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.48,399a.22.22,0,0,1-.11-.22.21.21,0,0,1,.17-.17c.15,0,3.57-.69,4.81.15a1,1,0,0,1,.46.66.76.76,0,0,1-.27.85,3.65,3.65,0,0,1-2.63-.19A15.1,15.1,0,0,1,187.48,399Zm.71-.05c1.47.71,3.55,1.4,4.11,1,.08-.05.17-.15.11-.44a.6.6,0,0,0-.29-.4,1.19,1.19,0,0,0-.36-.17A9.53,9.53,0,0,0,188.19,399Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.38,399a.2.2,0,0,1,0-.21c0-.1,1-2.24,2.35-2.74a1.52,1.52,0,0,1,1.2,0c.52.24.59.56.54.79-.14,1-2.72,2.1-3.85,2.2a.08.08,0,0,1-.08,0A.19.19,0,0,1,187.38,399Zm3.26-2.59a1.08,1.08,0,0,0-.75,0,4.89,4.89,0,0,0-1.95,2.15c1.23-.25,3-1.21,3.13-1.78,0-.06,0-.21-.31-.36l-.12,0Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.72,398.08a3.06,3.06,0,0,1,1.73,1.32c1.73,3.19,1.74,5.39,8,8.43,1.36.67-.55,4.29-3.9,3.1-5.56-2-4.16-2.13-8.91-3.74-4-1.37-7-2.17-10.21-3.21a1.15,1.15,0,0,1-.25-.12,1.27,1.27,0,0,1-.41-1.74l4.1-6.75.67-1.67A1.2,1.2,0,0,1,180,393l7.56,2.16a1.19,1.19,0,0,1,.77,1.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84,260.7,216,338.83l-24.63,52.8-10.91-4.2s9.41-29.82,16.29-46.17c1-2.38,1.95-4.48,2.81-6.16a44.67,44.67,0,0,0,4.27-12.55l0-.14,5.27-27.34a56.34,56.34,0,0,0,.89-13.66c-.38-6.85-.25-18,3.57-25.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.17,276.3,222.81,269l-3,.54s-4.57,11.21,11.67,28.81l3.88-10.14C233.29,281.89,231.17,276.3,231.17,276.3Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.63 383.96 179.49 387.92 191.94 392.71 193.81 388.92 180.63 383.96",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.17 382.29 286 401.99 277.98 403.08 271.86 384.21 281.17 382.29",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.67,401.74a.21.21,0,0,1-.18-.16.22.22,0,0,1,.1-.22c.13-.08,3.09-1.91,4.55-1.57a1.13,1.13,0,0,1,.67.46.77.77,0,0,1,0,.89,3.62,3.62,0,0,1-2.52.75A14.79,14.79,0,0,1,286.67,401.74Zm.65-.3c1.62.15,3.81.05,4.19-.53.06-.07.11-.19-.06-.44a.58.58,0,0,0-.41-.28,1.29,1.29,0,0,0-.39,0A9.52,9.52,0,0,0,287.32,401.44Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.56,401.73a.18.18,0,0,1-.1-.18c0-.11.15-2.45,1.23-3.4a1.5,1.5,0,0,1,1.13-.39c.56,0,.75.31.78.55.22,1-1.8,2.92-2.82,3.42a.11.11,0,0,1-.08,0A.22.22,0,0,1,286.56,401.73Zm2.13-3.58a1.12,1.12,0,0,0-.7.28,4.79,4.79,0,0,0-1.05,2.7c1.05-.67,2.36-2.19,2.29-2.78,0-.05-.05-.2-.42-.21Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.51,402.09l-1.43,7.76a1.25,1.25,0,0,0,1,1.48.82.82,0,0,0,.27,0c3.41-.18,6.44-.47,10.69-.62,5-.18,3.76.47,9.66.34,3.55-.08,4.06-4.14,2.54-4.28-6.92-.62-7.71-2.68-10.46-5.05a3.09,3.09,0,0,0-2.08-.62l-.5-2.16a1,1,0,0,0-1.07-.79l-8.45.66a1,1,0,0,0-.87,1.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.89,261s18.83,47.86,23.5,64.33c4.46,15.74,13.16,64.11,13.16,64.11l-11.28,3.29s-11.74-32.62-16.39-51.86c-.47-1.93-.86-3.73-1.17-5.35A42.14,42.14,0,0,0,250,320.76l0,0-19.5-30.84s-19.12-16.51-14.33-33.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.78 391.63 273.23 395.5 286.08 391.91 285.32 387.75 271.78 391.63",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44,236.43l6,3.59h6.22a3.13,3.13,0,0,1,2.52,1.26h0a3.15,3.15,0,0,1-.31,4.15l-2.69,2.63a3.15,3.15,0,0,1-3.28.72l-1.14-.41a3.11,3.11,0,0,1-1-.57L262.27,244l-5.6-2.87Z",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,237.05l3.45,1.9a9.48,9.48,0,0,1-4.16,5.78l-3.35-2.43Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.38,237.05l3.45,1.9a9.48,9.48,0,0,1-4.16,5.78l-3.35-2.43Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,201.77a3.3,3.3,0,0,1,3,1.92c2,4.29,7.26,15.38,11.94,20,5.86,5.83,18.24,13.54,18.24,13.54a10.28,10.28,0,0,1-4.31,6.3s-18.27-7.7-24.93-15.47-8-11.86-9.12-16.41C224.8,209,223.29,201.85,230.63,201.77Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.63,201.77a3.3,3.3,0,0,1,3,1.92c2,4.29,7.26,15.38,11.94,20,5.86,5.83,18.24,13.54,18.24,13.54a10.28,10.28,0,0,1-4.31,6.3s-18.27-7.7-24.93-15.47-8-11.86-9.12-16.41C224.8,209,223.29,201.85,230.63,201.77Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,210.27l.66-1.08,5.73,3.47-3.47,5.73-.35-.21c.44.89.95,1.84,1.58,2.85l5,3.05-1.3,2.15,1.1,1.32,1.59-2.63,5.73,3.47-2.32,3.84c.42.32.86.64,1.31,1l2.4-4,5.72,3.47-2.48,4.1,1.41.81,2.46-4.07,5.73,3.46-2.26,3.73c.51.26,1,.49,1.47.72l2.18-3.61,5.13,3.11a11.74,11.74,0,0,0,.82-1.4l-5.11-3.09,1.32-2.19-1.34-.91-1.37,2.26-5.73-3.47,1.63-2.7c-.43-.32-.87-.65-1.29-1l-1.73,2.84-5.72-3.47,2.27-3.76-.37-.36c-.26-.26-.53-.55-.79-.85l-2.5,4.13-5.73-3.47,3.47-5.72,1.75,1.05c-.74-1.11-1.47-2.29-2.17-3.5l-.13.22-5.73-3.47,2.19-3.6c-.3-.6-.59-1.19-.85-1.73l-2.72,4.49-5.73-3.47,3.47-5.72,3.86,2.34-.33-.73a3.3,3.3,0,0,0-3-1.92,7.81,7.81,0,0,0-2.43.37L225.28,207l-.37-.22A13.81,13.81,0,0,0,225.17,210.27Zm7.77,3.23,5.73,3.47-3.47,5.72-5.72-3.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,171.68s7.13-.89,6.3,2.54C263.93,176.84,260.18,171.89,258.26,171.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.26,171.68s7.13-.89,6.3,2.54C263.93,176.84,260.18,171.89,258.26,171.68Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.14 193.39 249.48 201.96 240.3 197.9 243.77 190.84 252.14 193.39",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,180.5c0,.57-.29,1-.68,1s-.72-.5-.71-1.05.3-1,.69-1S263.24,179.92,263.25,180.5Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,182.18l2.86,4.51a4.09,4.09,0,0,1-3.61.27Z",
    style: {
      fill: "#d54c38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.63,178c-.3,7.62-.6,10.84,2.91,15.18,5.55,4.64,14.89,5.37,17.5-2,2.36-6.61,2.45-17.94-4.81-21.87a10.6,10.6,0,0,0-14.36,4A10.14,10.14,0,0,0,240.63,178Z",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,193.85c-1.9,1.43-4.29.94-5.93.94a2.72,2.72,0,0,0-2.39,1.75C254.4,197,257.51,196.21,259.52,193.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,178.08a.33.33,0,0,0,.29,0,2.34,2.34,0,0,1,2.14.25.29.29,0,0,0,.42,0,.31.31,0,0,0-.06-.43,2.92,2.92,0,0,0-2.71-.37.32.32,0,0,0-.18.39h0A.4.4,0,0,0,260,178.08Z",
    style: {
      fill: "#1a2e35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.52,192.7c.7.07,2.44-.52,3.71-.09a2.84,2.84,0,0,0,3.13-.92l6.53-8.11,1.2-8s1.43-2.94,2.33-3.48c1.31-.78,5.34-.51,5.36-2.88s-5-.78-5-.78,2.48-3.63.3-4.34c-1.9-.61-3.83,3.26-3.83,3.26s-13.54-3.8-17.11,7.14c-2.5,7.69-.9,14,.73,16.57A3.56,3.56,0,0,0,243.52,192.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.67,166.52s-14-3.77-21.83,6.41,4.46,10.48,4.46,10.48l1,4.42A17,17,0,0,0,252.84,182l2.64-6.63Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.26,178.45c-2.18,2.79-7,5-7,5l1,4.42A16.42,16.42,0,0,0,247.7,186C247.61,183.78,247.14,176.05,245.26,178.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,188.51a1,1,0,0,1,1-1.32c2.86-.07,9.56-.9,12.81-6.88a22.77,22.77,0,0,0,2.61-13.61,1,1,0,0,1,1.1-1.13h0a1,1,0,0,1,.92.87c.38,2.74,1.18,11.95-4.26,17.67a15.67,15.67,0,0,1-13.27,5.14,1,1,0,0,1-.87-.74Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.34,188.51a1,1,0,0,1,1-1.32c2.86-.07,9.56-.9,12.81-6.88a22.77,22.77,0,0,0,2.61-13.61,1,1,0,0,1,1.1-1.13h0a1,1,0,0,1,.92.87c.38,2.74,1.18,11.95-4.26,17.67a15.67,15.67,0,0,1-13.27,5.14,1,1,0,0,1-.87-.74Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.7,181.44a5.88,5.88,0,0,1,.36,4.52c-.66,1.95-2.73,1.75-4,.21-1.15-1.39-2.18-4.08-.81-5.57A2.73,2.73,0,0,1,258.7,181.44Z",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,199s1.59-4.64,8.68-3.25,10.29,4.19,9.34,6.49Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.21,199s1.59-4.64,8.68-3.25,10.29,4.19,9.34,6.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,262l-32.31-3.26a4.65,4.65,0,0,1-4.11-5.53c.06-.3.13-.61.2-.93.41-1.73,1.65-3.75,2.18-6s.35-4.77,1-7.36c.53-2.22,1.85-4.52,2.4-6.82.49-2.05.21-4.1.7-6.09.44-1.82,1.65-3.59,2.07-5.29.48-1.92.16-3.75.59-5.41.53-2.09,1.79-3.93,2.19-5.4a16.22,16.22,0,0,1,18.83-11.45L253.24,201a5.82,5.82,0,0,1,4.49,7.22,126.81,126.81,0,0,0-3.25,17.64c-.18,1.47.4,3.76.21,5.32-.15,1.2-1.07,2.44-1.22,3.69-.18,1.51.41,3.83.22,5.4s-1.16,2.62-1.37,4.36c-.14,1.26.48,4.08.33,5.37-.2,1.8-1.19,3.62-1.4,5.46-.14,1.17-.28,2.18-.42,3.18A3.88,3.88,0,0,1,246.6,262Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,262l-32.31-3.26a4.65,4.65,0,0,1-4.11-5.53c.06-.3.13-.61.2-.93.41-1.73,1.65-3.75,2.18-6s.35-4.77,1-7.36c.53-2.22,1.85-4.52,2.4-6.82.49-2.05.21-4.1.7-6.09.44-1.82,1.65-3.59,2.07-5.29.48-1.92.16-3.75.59-5.41.53-2.09,1.79-3.93,2.19-5.4a16.22,16.22,0,0,1,18.83-11.45L253.24,201a5.82,5.82,0,0,1,4.49,7.22,126.81,126.81,0,0,0-3.25,17.64c-.18,1.47.4,3.76.21,5.32-.15,1.2-1.07,2.44-1.22,3.69-.18,1.51.41,3.83.22,5.4s-1.16,2.62-1.37,4.36c-.14,1.26.48,4.08.33,5.37-.2,1.8-1.19,3.62-1.4,5.46-.14,1.17-.28,2.18-.42,3.18A3.88,3.88,0,0,1,246.6,262Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,213.67c-1.23-2.92-2.25-5-2.25-5l-2.31-3L249.62,207s-1.67,15,4.94,21.22a11.74,11.74,0,0,1-.08-2.4C255.14,220.79,255.78,216.88,256.44,213.67Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.47,211.47a90,90,0,0,1,22.18,4.06.87.87,0,0,0,.46-1.68,91.73,91.73,0,0,0-22.64-4.12c-1.12,0-1.12,1.7,0,1.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221,222.26a67.57,67.57,0,0,1,29.24,6.13c1,.46,1.89-1,.87-1.5A69.45,69.45,0,0,0,221,220.52a.87.87,0,0,0,0,1.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218,234.36c9-.62,18.26,1.18,26.7,4.09,1.06.37,1.51-1.31.46-1.67-8.54-2.95-18.07-4.78-27.16-4.16-1.12.08-1.12,1.82,0,1.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.92,246.6c8.5-.31,17.3,1.66,25.53,3.46,1.09.24,1.56-1.43.46-1.67-8.35-1.84-17.36-3.84-26-3.53-1.12,0-1.12,1.78,0,1.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M345,252.28l-78.09-7.49a.88.88,0,0,1-.8-1l.19-2a.89.89,0,0,1,1-.8l78.09,7.48a.87.87,0,0,1,.78.95l-.2,2.05A.87.87,0,0,1,345,252.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345,252.28l-78.09-7.49a.88.88,0,0,1-.8-1l.19-2a.89.89,0,0,1,1-.8l78.09,7.48a.87.87,0,0,1,.78.95l-.2,2.05A.87.87,0,0,1,345,252.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285,237l6,3.6h6.22a3.13,3.13,0,0,1,2.52,1.26h0a3.15,3.15,0,0,1-.31,4.15l-2.69,2.63a3.16,3.16,0,0,1-3.28.72l-1.14-.41a3.27,3.27,0,0,1-1-.57l-4.46-3.83-5.6-2.87Z",
    style: {
      fill: "#e67b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,237.59l3.45,1.9a9.56,9.56,0,0,1-4.16,5.78l-3.35-2.44Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,237.59l3.45,1.9a9.56,9.56,0,0,1-4.16,5.78l-3.35-2.44Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,202.31a3.31,3.31,0,0,1,3,1.91c1.95,4.3,7.26,15.39,11.94,20,5.86,5.83,18.24,13.54,18.24,13.54a10.24,10.24,0,0,1-4.31,6.29s-18.27-7.69-24.93-15.46-8-11.86-9.12-16.41C249.39,209.51,247.88,202.39,255.22,202.31Z",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,202.31a3.31,3.31,0,0,1,3,1.91c1.95,4.3,7.26,15.39,11.94,20,5.86,5.83,18.24,13.54,18.24,13.54a10.24,10.24,0,0,1-4.31,6.29s-18.27-7.69-24.93-15.46-8-11.86-9.12-16.41C249.39,209.51,247.88,202.39,255.22,202.31Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,236.83l1.45-1.71-1.25-.85-1.35,1.59-4.74-4,1-1.16-1.21-.9-.92,1.09-4.74-4,.83-1c-.39-.34-.76-.68-1.12-1l-.86,1-4.75-4,1.59-1.87c-.29-.43-.58-.87-.86-1.31l-1.87,2.2-4.75-4,3.29-3.88-.76-1.43-3.68,4.33-4.74-4,4-4.74,3.75,3.18c-.63-1.22-1.19-2.37-1.68-3.4l-1.1-.93.42-.5c-.21-.44-.4-.87-.56-1.23l-.15-.26-.86,1-3.05-2.59a6.86,6.86,0,0,0-1.81.44l3.89,3.3-4,4.74-2.77-2.35a16.18,16.18,0,0,0,.26,2.2l1.54,1.3-1,1.13c.15.58.32,1.16.5,1.74l1.61-1.89,4.74,4-3.52,4.14c.26.44.55.88.85,1.34l3.82-4.5,4.74,4-4,4.74-3.9-3.3c1.08,1.54,2.41,3.25,4.06,5.18.34.39.7.78,1.09,1.16L264,232.9h0a79,79,0,0,0,9.21,5.82l-1.18-1,4-4.74,4.74,4L277.39,241l1.39.69,3.1-3.66,4.63,3.93a10.68,10.68,0,0,0,.84-1.27Zm-22.67-9.1,4-4.74,4.74,4-4,4.74Zm10.63,9-4.74-4,4-4.75,4.74,4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.93 207.72 303.9 210.57 326.93 232.11 309.93 207.72",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.93 207.72 303.9 210.57 326.93 232.11 309.93 207.72",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.93 257.79 308.47 264.72 312.21 266.58 303.09 271.69 308 273.56 317.87 265.67 314.09 264.72 323.93 257.79",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.93 257.79 308.47 264.72 312.21 266.58 303.09 271.69 308 273.56 317.87 265.67 314.09 264.72 323.93 257.79",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.2 263.48 320.66 276.63 323.93 276.63 327.2 263.48",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.2 263.48 320.66 276.63 323.93 276.63 327.2 263.48",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.67 232.7 310.06 229.69 325.15 238.92 305.67 232.7",
    style: {
      fill: "#2C005B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.67 232.7 310.06 229.69 325.15 238.92 305.67 232.7",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTobacoNo);
export default __webpack_public_path__ + "static/media/tobaco-no.f299ee7d3b823f1141b3f3bad5a9e61e.svg";
export { ForwardRef as ReactComponent };